import * as React from "react";
import { createBrowserRouter } from "react-router-dom";
import CommonElement from "../CommonElement";
import Homepage from "../Pages/Homepage";
import Openposition from "../Pages/Openposition";
import Jobdetails from "../Pages/Jobdetails";
import AppliedJob from "../Pages/AppliedJob";
import ProfileSection from "../Pages/ProfileSection";
import ProtectedRoute from "../Store/Middleware/PR";
import Unsubscribe from "../Pages/Unsubscribe";
import { LinkedInCallback } from "react-linkedin-login-oauth2";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <CommonElement />,
    children: [
      {
        path: "/",
        element: <ProtectedRoute Component={Homepage} />,
      },
      {
        path: "/authPage/jobdetails/openposition",
        element: <Openposition />,
      },
      {
        path: "/authPage/jobdetails/:id",
        element: <Jobdetails />,
        
      },
      {
        path: "/authPage/jobdetails/appliedJob",
        element: <ProtectedRoute Component={AppliedJob} />,
      },
      {
        path: "/authPage/profileSection",
        element: <ProtectedRoute Component={ProfileSection} />,
      },
      {
        path: "/candidate/unsubscribe/:email",
        element: <Unsubscribe />,
      },
      {
        path:"/linkedin", element: <LinkedInCallback />,
      }

    ],
  },
]);